import "../../plugins/jquery.chase.js";
import "../../plugins/smooth-scroll.js";
import Vue from "vue/dist/vue.esm.js";
import axios from 'axios';
import _ from 'lodash';

const URL_BASE = '/faq/faq.json';
const URL_BASE_CATEGORIES = '/faq/faq_categories.json';

var app = new Vue({
  el: '#app',
  data() {
    return {
      keyword: '',
      categories: [],
      search_list: [],
      total: 0
    };
  },
  mounted() {
    $(function () {
      setTimeout(function () {
        $('#scrollFixedBox-js nav li').chase({ target: '.currentPoint', targetMarginTop: 100 });

        $("a[href*='#']").each(function () {
          var href = $(this).attr('href');
          if (href && href !== "#") {
            var id = href.substring(href.indexOf("#"), href.length);
            if (($(id).length)) {
              // console.log(href)
              $(this).attr('data-scroll', '');
            }
          }
        });
        //data-scrollがついているものはスムーススクロール
        smoothScroll.init({
          speed: 500,
          offset: topMargin = $(window).width() >= 1024 ? 84 : 47
        });
      }, 1000);
    })
  },
  filters: {
    searchHighlight(v, keyword) {
      var keywords = keyword.toLowerCase().split(/\s+/);
      var text = v.toLowerCase();


      //NGワード htmlを格納 + ハイライト用のhtmlも格納
      var nghtml = v.toLowerCase().match(/<("[^"]*"|'[^']*'|[^'">])*>/g);
      if (nghtml) {
        nghtml.push('<span class="faq-textHighlight">');
        // nghtml.push("hoge")
        // console.log(nghtml)
      } else {
        nghtml = ['<span class="faq-textHighlight">']
        // console.log(nghtml)
      }
      var hithtml = true;



      var aaa = "";
      // console.log(keywords)
      // 検索キーワードが入力されているとき
      if (keyword) {
        // 検索キーワードに一致する部分を、spanタグに置換すればいいね
        // return v.replace(keyword.toLowerCase(), `<span class="bg-warning">${keyword.toLowerCase()}</span>`)

        keywords.map(function (value) {
          // var k = value.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '')

          var regex = /<("[^"]*"|'[^']*'|[^'">])*>/g;
          var regex2 = /[^\s　]/;

          //html含まれているか判定
          var result = false;
          if (regex.test(v)) {
            if (v.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g).toLowerCase().indexOf(value) > -1) {
              result = false
            } else {
              result = true
            }
          }
          // console.log(value.replace(/口座/g, ""))
          // console.log(regex2.test(value));
          if (!result) {
            //空白無効
            if (regex2.test(value)) {
              var k = value.toLowerCase();
              var reg = new RegExp(k.replace("+", "\\+"), 'g');
              // console.log(k.replace("+", "\\+"))
            }


            //NGワードにヒットしたらハイライトしない
            if (nghtml) {
              // console.log(nghtml.join('').match(value))
              if(nghtml.join('').match(value)) {
                hithtml = false;
              }
            }

            if(hithtml) {
              // text = text.replace(reg, `<span class="faq-textHighlight">${value.toLowerCase()}</span>`)
              text = text.replace(reg, `<span class="faq-textHighlight">${value.toLowerCase()}</span>`)
            }


          }

          // console.log(text);
        });

        return text
      }
      // 検索キーワードが入力されていない場合は、ハイライトしない
      return v
    }
  },
  computed: {
    hoge: function () {
      return this.keyword
    },
    // filteredItems: function () {

    //   var items = [];

    //   for (var i in this.search_list) {
    //     var item = this.search_list[i];

    //     if (item.title.toLowerCase().includes(this.keyword) ||
    //       item.text.toLowerCase().includes(this.keyword)) {


    //       items.push(item);
    //     }

    //   }

    //   return items;

    // },
    // categoryView: function() {
    //   for(var category of this.categories) {
    //     var list2 = _.filter(this.search_list, ["category", category]);
    //     console.log(list2)
    //   }

    // },
    filteredView: function () {

      return function (v) {
        var items = [];
        var t = 0;

        var list2 = _.filter(this.search_list, ["category", v]);
        var categoryCount = _.find(this.categories, ["category", v]);

        // for (var category of this.categories) {
        //   var list2 = _.filter(this.search_list, ["category", v]);
        //   console.log(list2)
        // }

        for (var i in list2) {

          var item = list2[i];
          var n = this.keyword.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '')
          var k = this.keyword.toLowerCase().split(/\s+/)

          var regex = /<("[^"]*"|'[^']*'|[^'">])*>/g;

          //htmlを取り除く
          var text = item.text.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
          // console.log(text)

          var htmlMatch = false
          // result2.map(function(){

          // })


          if (k.map(q => item.title.toLowerCase().indexOf(q) > -1 || text.toLowerCase().indexOf(q) > -1)
            .every(result => result === true)) {

            // console.log(result2.join('').indexOf(v))

            // if(result2) {
            //   k.map(function (v) {
            //     console.log(result2.join('').indexOf(v))

            //   });
            // }

            items.push(item);

          }


        }

        categoryCount.count = items.length;
        var countArray = _.map(this.categories, "count");
        this.total = countArray.reduce(function (total, data) {
          return total + data
        });
        // var list2 = _.map(this.categories, 'count');


        // array = [10, 40, 50, 30, 63];
        // //足し算
        // sum = array.reduce((a, x) => a += x, 0);

        // console.log(total)


        return items;
      };


      // return this.search_list.filter( item => {
      //   return this.keyword.toLowerCase()
      //     .split(/\s+/)
      //     .map( q => item.title.toLowerCase().indexOf(q) > -1 || item.text.toLowerCase().indexOf(q) > -1 )
      //     .every( result => result === true )
      // })
    }
  },
  methods: {
    zero: function (v) {
      return String(v).padStart(2, "0");
    },
    inputDelete: function (v) {
      // console.log(v)
      // this.searchHighlight("a",v)
      this.keyword = '';

    }
  },
  async created() {
    try {
      let res = await axios.get(URL_BASE)
      let res2 = await axios.get(URL_BASE_CATEGORIES)
      this.search_list = res.data
      this.categories = res2.data
    } catch (e) {
      console.error(e)
    }
  }
})

// export default {

// };


// $('.faq-input__delete').on('click', function() {
//   $('.faq-input').val('wallet');
// })

//別ページからのアンカーリンク対応


$(window).on('load', function () {
  // console.log("sss")
  var winWidth = $(window).width();
  var topMargin = winWidth >= 767 ? 80 : 50;
var hash = location.hash;
// console.log(hash);
// var target = $("#" + hash);
if (hash) {
  // $('html,body').animate({ scrollTop: 0 }, '0');
  var position = $(hash).offset().top - topMargin;
    // $('html,body').show();
    $("html, body").animate({ scrollTop: position }, 500, "swing");
  }
});